module.exports = __webpack_public_path__ + "img/disabled.be96128a.svg";